import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '@app/modules/shared.module';
import { UtilsModule } from '@app/modules/utils.module';
import { MaterialImports } from '@environments/environment';
import { CustomFormsModule } from '@app/modules/forms.module';
import { FormsModule } from '@angular/forms';
import { CashoutComponent } from '@components/cashout.component';
import { BetStopReasonModule } from '@components/betStopReason/betStopReason.module';
import { LiveTrackerComponent } from '@components/livetracker.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
const routes: Routes = [
  {
    path: '',
    component: CashoutComponent,
  },
];
@NgModule({
  declarations: [CashoutComponent, LiveTrackerComponent],
  exports: [CashoutComponent, LiveTrackerComponent],
  imports: [CommonModule, SharedModule, UtilsModule, MaterialImports, RouterModule.forChild(routes), CustomFormsModule, FormsModule, BetStopReasonModule, NgxSkeletonLoaderModule],
})
export class CashoutModule {}
